<template>
  <div>
    <el-row :gutter="10"
            style="display: flex; flex-wrap: wrap; row-gap: 16px;">
      <el-col :span="12"
              v-for="(item, index) in listData"
              :key="index">
        <div class="card-container"
             @click="handleOpenDialog(item)">
          <!-- 卡片主体 -->
          <div class="card-image-wrapper">
            <el-image class="card__img"
                      :src="item.cover"
                      :alt="item.title"
                      fit="contain">
              <div slot="error"
                   class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <!-- 卡片底部 -->
          <div class="card-footer">
            <h3 class="fit-number">
              {{ item.title }}
            </h3>
            <span class="pieces-count">
              {{ item.goodsTotal || '-' }} pieces
            </span>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 等待状态提示：请上传图片搜索 -->
    <div class="nodata"
         v-if="!loading && listData.length === 0"
         style="margin-top: 100px;">
      <img src="@/assets/images/nodata.png">
      <span>Please upload an image to search</span>
    </div>

    <el-dialog :title="dialogData.title"
               class="suit-dialog--bg"
               custom-class="suit-dialog"
               :visible.sync="dialogVisible"
               append-to-body
               :before-close="handleClose">
      <div class="suit-dialog__scroll-container">
        <!-- 中央大图区域 -->
        <div class="suit-dialog__image-section">
          <el-image class="suit-dialog__main-image"
                    :src="dialogData.cover"
                    :alt="dialogData.title"
                    fit="contain">
            <div slot="error"
                 class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>

        <!-- EVERY PIECE 列表区域 -->
        <div class="suit-dialog__list-section">
          <div class="suit-dialog__section-title">
            EVERY PIECE
          </div>
          <div class="suit-dialog__items">
            <div class="suit-dialog__item"
                 v-for="item in dialogData.goodsSuitDetailList"
                 :key="item.id"
                 @click="handleBuy(item)">
              <div class="suit-dialog__item-image">
                <img :src="item.goodsImage"
                     :alt="item.goodsName"
                     class="image" />
              </div>
              <div class="suit-dialog__item-info">
                <div class="suit-dialog__item-category">
                  {{ item.categoryName }}
                </div>
                <div class="suit-dialog__item-name">
                  {{ item.goodsName }}
                </div>
              </div>
              <div class="suit-dialog__item-price">
                {{ item.currencySymbol }}{{ item.price }}
              </div>
              <svg class="suit-dialog__item-arrow"
                   width="16"
                   height="16"
                   viewBox="0 0 24 24"
                   fill="none"
                   stroke="currentColor"
                   stroke-width="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { openPlatformBuy, reportGoodsClick } from '@/utils/goodsAction'

export default {
  name: "Card",
  props: {
    loading: Boolean,

    listData: Array,
  },
  data() {
    return {
      dialogVisible: false,
      dialogData: {},
      selectPlatform: {}
    }
  },

  created() {
    this.selectPlatform = JSON.parse(sessionStorage.getItem('homeData')).expert.expertPlatformList[0]
  },

  methods: {
    handleOpenDialog(item) {
      this.dialogVisible = true
      this.dialogData = item
      // 点击商品套装卡片，统计点击事件
      reportGoodsClick(item, 'suit')
    },
    handleClose(done) {
      done()
    },

    handleBuy(goods) {
      this.selectPlatform = JSON.parse(sessionStorage.getItem('selectPlatform')) || this.selectPlatform

      reportGoodsClick(goods)
      openPlatformBuy(this.selectPlatform, goods)
    }
  }
}
</script>

<style scoped lang="scss">
.card-container {
  height: 100%;
  border-radius: 8px;
  background-color: var(--background-color);
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: .5px solid hsl(from var(--primary-color) h s l / 0.15);
}

/* hover状态 */
.card-container:hover {
  border: .5px solid hsl(from var(--primary-color) h s l / 0.6);
  box-shadow: 0 4px 20px hsl(from var(--select-color) h s l / 0.35);
}

/* 图片容器 */
.card-image-wrapper {
  flex: atuo;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.card-image-wrapper .card__img {
  width: 100%;
  height: 100%;
  min-height: min(300px, 50vw);
  transition: transform 0.3s ease;
  background-color: var(--background-color);

  :deep(.el-image),
  :deep(.el-image__placeholder),
  :deep(.el-image__error),
  :deep(.el-image__inner) {
    background-color: var(--background-color);
  }
}

:deep(.image-slot) {
  height: 100%;
  min-height: min(300px, 50vw);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 38px;
  color: var(--link-color);
}

/* hover时图片放大 */
.card-container:hover .card-image-wrapper .card__img {
  transform: scale(1.04);
}

.card-footer {
  flex: none;
  padding: 12px 16px;
  background-color: #272727;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 16px;
}

.fit-number {
  font-family: "DM Sans", -apple-system, sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: var(--primary-color);
  margin: 0;
}

.pieces-count {
  margin-left: auto;
  font-size: 12px;
  color: hsl(from var(--primary-color) h s l / 0.3);
}
</style>

<style lang="scss">
.suit-dialog--bg {
  background: #000000;
}

.suit-dialog {
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 560px;
  width: 90% !important;
  margin: 0 !important;
  background-color: var(--background-color) !important;
  border-radius: 12px;
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #a0a0a0 #ffffff;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 2px;
  }

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid hsl(from var(--select-color) h s l / 0.1);
  }

  .el-dialog__title {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: .14em;
    text-transform: uppercase;
    color: hsl(from var(--primary-color) h s l / 0.8) !important;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: hsl(from var(--primary-color) h s l / 0.5) !important;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__close {
    color: var(--select-color);
    font-size: 24px;
    top: 16px;
    right: 20px;
  }

  .suit-dialog__scroll-container {
    width: 100%;
  }

  .suit-dialog__image-section {
    width: 100%;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: hsl(from var(--select-color) h s l / 0.02);
  }

  .suit-dialog__main-image {
    width: 100%;
    min-height: min(300px, 50vw);
  }

  .suit-dialog__list-section {
    padding: 24px;
  }

  .suit-dialog__section-title {
    font-size: 10px;
    letter-spacing: .16em;
    text-transform: uppercase;
    color: hsl(from var(--primary-color) h s l / 0.5);
    font-weight: 500;
    margin-bottom: 10px;
  }

  .suit-dialog__items {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .suit-dialog__item {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    background-color: hsl(from var(--select-color) h s l / 0.03);
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: hsl(from var(--select-color) h s l / 0.06);
    }
  }

  .suit-dialog__item-image {
    width: 48px;
    height: 48px;
    padding: 8px;
    margin-right: 16px;
    border: 1px solid hsl(from var(--select-color) h s l / 0.1);
    border-radius: 8px;

    .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .suit-dialog__item-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .suit-dialog__item-category {
    font-size: 12px;
    font-weight: 600;
    color: hsl(from var(--select-color) h s l / 0.5);
    text-transform: uppercase;
  }

  .suit-dialog__item-name {
    font-size: 14px;
    font-weight: 500;
    color: var(--select-color);
  }

  .suit-dialog__item-price {
    color: var(--primary-color);
    margin: 0 12px;
    font-size: 14px;
    font-weight: 500;
    flex-shrink: 0;
    font-family: "DM Sans", -apple-system, sans-serif;
  }

  .suit-dialog__item-arrow {
    color: hsl(from var(--primary-color) h s l / 0.5);
    flex-shrink: 0;
  }
}

.suit-dialog::before {
  content: "";
  display: block;
  height: 2px;
  background: linear-gradient(90deg, transparent, hsl(from var(--primary-color) h s l / 0.5), var(--primary-color), hsl(from var(--primary-color) h s l / 0.5), transparent);
}

@media (max-width: 425px) {
  .suit-dialog {
    position: fixed !important;
    top: auto;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 100% !important;
  }
}
</style>